import { Button, Container, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      <Typography
        variant="h1"
        sx={{ fontSize: "6rem", fontWeight: "bold", color: "primary.main" }}
      >
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        You may have mistyped the address or the page may have moved.
      </Typography>
      <Button
        component={Link}
        to="/"
        variant="contained"
        color="primary"
        size="large"
        sx={{ textTransform: "none" }}
      >
        Go to Homepage
      </Button>
    </Container>
  );
}
